import { action, Action, thunk, Thunk } from 'easy-peasy';
import { CollapseType } from '@meitu/saas-editor-ui/es/types';

export interface ICollapseModel {
    /**
     * 当前面板类型
     */
    currentType: CollapseType | null;

    /**
     * 当前真实渲染的面板类型
     */
    actualType: CollapseType | null;

    /**
     * 设置当前面板类型
     */
    setCurrentType: Action<ICollapseModel, CollapseType>;

    /**
     * 获取当前面板类型
     */
    getCurrentType: Thunk<ICollapseModel>;

    /**
     * 设置当前面板类型为空
     */
    destroy: Action<ICollapseModel>;

    /**
     * 设置当前真实渲染的面板类型
     */
    setActualType: Action<ICollapseModel, CollapseType | null>;

    /**
     * 同时设置当前面板类型和真实渲染的面板类型
     */
    setBothType: Action<ICollapseModel, CollapseType | null>;
}

export const collapseModel: ICollapseModel = {
    currentType: null,

    actualType: null,

    destroy: action((state) => {
        state.currentType = null;
    }),

    setCurrentType: action((state, payload) => {
        state.currentType = payload;
    }),

    getCurrentType: thunk((actions, payload, { getState }) => {
        return getState().currentType;
    }),

    setActualType: action((state, payload) => {
        state.actualType = payload;
    }),

    setBothType: action((state, payload) => {
        state.currentType = payload;
        state.actualType = payload;
    }),
};
